import { Component, OnInit } from '@angular/core';
import { auth } from 'firebase';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(public cm:CommonService) { }

  ngOnInit() {
  }

  email_input;
  password_input;
  loading = false;
  login(){
    this.loading = true;
    if(this.cm.checkinput(this.email_input,'>',3) && this.cm.checkinput(this.password_input,'>',5)){
      this.cm.afAuth.auth.signInWithEmailAndPassword(this.email_input, this.password_input).then(value => {
        this.loading = false;
        var data = {
          uid:value.user.uid,
          email:value.user.email
        }
        
        // this.cm.saveProfile(data);

        // check permission
        this.cm.db.collection('admin').doc(data.uid).get().toPromise().then((data)=>{
          this.cm.toastr.success('เข้าสู่ระบบสำเร็จ','สำเร็จ');
          // save data to storage
          this.cm.saveProfile(data.data())
          this.cm.goto('dashboard');
          // this.loading = false;
        }).catch(err=>{
          this.cm.toastr.warning('อีเมล หรือ รหัสผ่านของคุณผิด','แจ้งเตือน');
          this.password_input = '';
          this.loading = false;
        })
        // this.cm.goto('dashboard');
        // this.cm.toastr.success('เข้าสู่ระบบสำเร็จ','สำเร็จ');
      }).catch(err => {
        this.cm.toastr.warning('อีเมล หรือ รหัสผ่านของคุณผิด','แจ้งเตือน');
        this.password_input = '';
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.password_input = '';
      this.cm.toastr.warning('มีบางอย่างผิดปกติ','แจ้งเตือน');
    }
  }

  member_profile = {
    name : '',
    email : '',
    uid:'',
    room_uid:''
  }
  signup(){
    this.cm.afAuth.auth.signInWithPopup(new auth.GoogleAuthProvider()).then((data)=>{

      this.member_profile.name = data.user.displayName;
      this.member_profile.email = data.user.email;
      this.member_profile.uid = data.user.uid;

      this.cm.db.collection('members').doc(data.user.uid).get().toPromise().then((data)=>{

        if(!data.data()){
          this.cm.db.collection('members').doc(this.member_profile.uid).set(this.member_profile).then((data)=>{
            this.cm.toastr.success('ADD MEMBER','SUCCESS');
          });
        }

      }).catch((error)=>{

        
      })
    })
  }

}
